module.exports = __webpack_public_path__ + "static/marilith-ffc88ba191cde9c57cf282c0b3abf01c.jpeg";